import type { HostedAuthPlugin } from '@unipile/ui';
import { Wizard } from './components/Wizard';

export const mockProviderHaPlugin: HostedAuthPlugin = {
  Component: Wizard,
  registerTrads({ locales }) {
    return Promise.all(
      locales.map(async () => {
        // const data: { default: object } = await import(`./translations/${locale}.json`);
        // i18n.addResourceBundle(locale, 'mock', data.default);
      }),
    );
  },
};
